import { nanoid } from "nanoid/non-secure";
export function noop() {
    // do nothing
}
export function generateId() {
    return nanoid(10);
}
export function removeUndefined(obj) {
    const result = {};
    for (const key in obj) {
        const value = obj[key];
        if (value !== undefined) {
            result[key] = value;
        }
    }
    return result;
}
export function getOptionUpdater(options) {
    return function (key, value) {
        if (value === undefined)
            return;
        const store = options[key];
        store.set(value);
    };
}
export function builderActions(node, params) {
    const unsubs = [];
    params.builders.forEach((builder) => {
        const act = builder.action(node);
        if (act) {
            unsubs.push(act);
        }
    });
    return {
        destroy: () => {
            unsubs.forEach((unsub) => {
                if (unsub.destroy) {
                    unsub.destroy();
                }
            });
        }
    };
}
export function getAttrs(builders) {
    const attrs = {};
    builders.forEach((builder) => {
        Object.keys(builder).forEach((key) => {
            if (key !== "action") {
                attrs[key] = builder[key];
            }
        });
    });
    return attrs;
}
export function disabledAttrs(disabled) {
    return disabled ? { "aria-disabled": true, "data-disabled": "" } : {};
}
export function bitWrap(storeValues, bit) {
    return {
        ...storeValues,
        [`data-bits-${bit}`]: ""
    };
}
